import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MetricCard from "./MetricCard";
import FeatureCard from "./FeatureCard";
// import miVideo from "../assets/img/videomain.mp4";
import miVideo from "../assets/img/en_Construccion.mp4";
// import img2 from "../assets/img/oficiona_Fomex.jpg";
// import img2 from "../assets/img/img2.jpg";
// import conflo from "../assets/img/Conflo-Logo.jpg";
// import rojokaram from "../assets/img/ROJO-KARAM®-LOGO.jpg";
import { Icons } from "../assets/icons/icons";
import arcotecho from "../assets/img/Obras/arco_Techo.png";
import casaseina from "../assets/img/Obras/casa_Siena.png";
import { motion } from "framer-motion";

// Datos para Carrusel
const carouselProjects = [
  {
    id: 1,
    imageUrl: arcotecho,
    title: "Arco Techo",
    category: "Construccion, Infraestructura",
    meta: "CONSTRUCCIÓN / INFRAESTRUCTURA",
    description:
      "Diseño que optimiza el espacio al aire libre, proporcionando una amplia área sin columnas intermedias, ideal para actividades deportivas y comunitarias.",
    stats: ["+500 Mts² de Construcción", "4 Meses de Ejecución"],
  },
  {
    id: 2,
    title: "Casa Siena",
    category: "Inmobiliario",
    meta: "DESARROLLO / DISEÑO",
    description:
      "Un diseño exterior limpio y minimalista que proyecta elegancia y modernidad. Los detalles en piedra volcánica aportan carácter y calidez a la estructura, prometiendo un hogar luminoso y espacioso",
    stats: [" ", ""],
    imageUrl: casaseina,
  },
];

const Body = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = carouselProjects.length;
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollToSection = (sectionId) => {
    if (location.pathname === "/") {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        const offset = 100;
        const elementPosition = sectionElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "auto",
        });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const sectionElement = document.getElementById(sectionId);
        if (sectionElement) {
          const offset = 100;
          const elementPosition = sectionElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "auto",
          });
        }
      }, 300);
    }
  };

  const navigateTo = {
    inicio: () => navigate("/"),
    conflo: () => navigate("/Conflo"),
    rojokaram: () => navigate("/Rojokam"),
    rikpak: () => navigate("/Rikpak"),
    sienepmc: () => navigate("/Sienepmc"),
    siendci: () => navigate("/Siendci"),
  };

  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    empresa: "",
    asunto: "",
    mensaje: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const isValidEmailFormat = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    if (!isValidEmailFormat(formData.email)) {
      setSubmitStatus("error_validation_format");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(
        "https://api.emailjs.com/api/v1.0/email/send",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            service_id: "service_o52p3gr",
            template_id: "template_j3siguu",
            user_id: "5Pd6JipwBwYms4tdy",
            template_params: {
              from_name: formData.nombre,
              reply_to: formData.email,
              email: formData.email,
              phone: formData.telefono,
              company: formData.empresa,
              subject: formData.asunto,
              message: formData.mensaje,
              to_email: "administracion@grupofomex.com",
            },
          }),
        }
      );

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({
          nombre: "",
          email: "",
          telefono: "",
          empresa: "",
          asunto: "",
          mensaje: "",
        });
        setTimeout(() => setSubmitStatus(null), 5000);
      } else {
        const errorData = await response.text();
        console.error("Error en la respuesta de EmailJS:", errorData);
        setSubmitStatus("error_submission");
      }
    } catch (error) {
      console.error("Error de conexión:", error);
      setSubmitStatus("error_connection");
    } finally {
      setIsSubmitting(false);
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  useEffect(() => {
    const autoplayInterval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(autoplayInterval);
  }, [totalSlides]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  const videoVariants = {
    hidden: { opacity: 0, x: 100, rotate: 0 },
    visible: {
      opacity: 1,
      x: 0,
      rotate: 3,
      transition: { duration: 0.8, type: "tween", ease: "easeOut" },
    },
  };

  return (
    <>
      {/* SECCIÓN 1: INICIO */}
      <section
        id="inicio"
        className="relative bg-gradient-to-br from-fomex-blue-50 to-fomex-blue-100 pt-20 pb-12 overflow-hidden"
      >
        <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8 py-10">
          <div className="flex flex-col lg:flex-row w-full gap-16 items-center">
            {/* CONTENIDO DE TEXTO Y BOTONES (Animado) */}
            <motion.div
              className="w-full lg:w-1/2 pt-8 order-2 lg:order-1"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              {/* Título Principal (Animado) */}
              <motion.h2
                className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight"
                variants={itemVariants}
              >
                Grupo Empresarial <br />
                <span className="text-5xl md:text-6xl font-extrabold text-blue-700">
                  Diversificado
                </span>
              </motion.h2>

              <motion.p
                className="mt-8 text-lg text-gray-700 max-w-xl leading-relaxed"
                variants={itemVariants}
              >
                Expertos en soluciones integrales de construcción. Somos un
                grupo empresarial especializado en llevar a cabo proyectos con
                excelencia operacional y rigor técnico, asegurando que cada obra
                sea sinónimo de compromiso y resultados superiores.
              </motion.p>

              {/* Contenedor de Botones  */}
              <motion.div
                className="mt-10 flex flex-wrap gap-4"
                variants={itemVariants}
              >
                <button
                  className="btn-primary-fomex"
                  onClick={() => handleScrollToSection("empresas")}
                >
                  Conoce Nuestras Empresas
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    ></path>
                  </svg>
                </button>
                <button
                  className="btn-secondary-fomex"
                  onClick={() => handleScrollToSection("servicios")}
                >
                  Ver Servicios
                </button>
              </motion.div>

              {/* Métricas */}
              <motion.div
                className="mt-16 grid grid-cols-3 gap-6 max-w-xl"
                variants={itemVariants}
              >
                <MetricCard
                  Icon={Icons.Trophy}
                  value="8+"
                  label="Años De Experiencia"
                />
                <MetricCard Icon={Icons.Users} value="100+" label="Empleados" />
                <MetricCard Icon={Icons.Target} value="2" label="Empresas" />
              </motion.div>
            </motion.div>

            {/* TARJETA DE VIDEO  */}
            <motion.div
              className="w-full lg:w-1/2 order-1 lg:order-2 relative flex justify-center items-center"
              variants={videoVariants}
              initial="hidden"
              animate="visible"
            >
              <div className="relative w-full max-w-2xl h-[600px] shadow-2xl rounded-xl overflow-hidden transform">
                <div className="w-full h-full bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center">
                  <video
                    src={miVideo}
                    className="w-full h-full object-cover rounded-xl"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                </div>
                <div className="absolute inset-0 bg-gray-900/10"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* SECCIÓN 2: ABOUT */}
    </>
  );
};

export default Body;
